<template>

  <div class="container-fluid">
    <div class="pt-4">
      <h2 class="bold">Definições</h2>
    </div>

    <div class="row">
      <div class="col-md-12 mt-5">
        <TabContainer @selected="updateQueryUri($event)">

          <Tabs
              v-if="$withPolicy('application', 'myAccount')"
              :start-active="tab==='accounts'"
              @clicked="updateQueryUri('accounts')"
              name="Minha Conta" id="accounts"
          >

            <MyAccount/>

          </Tabs>

          <Tabs
              :start-active="tab==='companies'"
              @clicked="updateQueryUri('companies')"
              name="Empresas e Filiais" id="companies"
          >
            <CompanyContainer/>
          </Tabs>

          <Tabs
              v-if="this.getUser.role === 'owner' && showProviders"
              :start-active="tab==='providers'"
              @clicked="updateQueryUri('providers')"
              name="Fornecedores" id="providers"
          >
            <ProviderContainer/>
          </Tabs>

          <Tabs
            v-if="showVehicles"
            :start-active="tab==='vehicles'"
            id="vehicles"
            name="Veículos"
            @clicked="updateQueryUri('vehicles')"
          >
            <VehicleContainer/>
          </Tabs>

          <Tabs
            v-if="showDrivers"
            :start-active="tab==='drivers'"
            id="drivers"
            name="Motoristas"
            @click.native="updateQueryUri('drivers')"
          >
            <DriverContainer/>
          </Tabs>

          <Tabs
            v-if="showVehicles && this.getUser.role === 'owner'"
            :start-active="tab==='credential'"
            id="credential"
            name="Credenciais"
            @clicked="updateQueryUri('credential')"
          >
            <CredentialContainer/>
          </Tabs>

          <Tabs
            v-if="showCustomFields && this.getUser.role === 'owner'"
            :start-active="tab==='custom_fields'"
            id="custom_fields"
            name="Campos personalizados"
            @clicked="updateQueryUri('credential')"
          >
            <CustomFieldIndex/>
          </Tabs>

          <Tabs
              v-if="$withPolicy('application', 'users')"
              :start-active="tab === 'users'"
              @click.native="updateQueryUri('users')"
              name="Usuários" id="users"
          >
            <UserContainer/>
          </Tabs>

          <Tabs
              v-if="$canNew('application', 'permission_groups')"
              :start-active="tab === 'permission_groups'"
              @click.native="updateQueryUri('permission_groups')"
              name="Grupos de Permissão" id="permission_groups"
          >
            <PermissionGroupsContainer/>
          </Tabs>

          <Tabs
              v-if="$withPolicy('application', 'events')"
              :start-active="tab === 'events'"
              @click.native="updateQueryUri('events')"
              name="Histórico de Ações" id="events"
          >
            <EventContainer/>
          </Tabs>

          <Tabs
              :start-active="tab === 'notifications'"
              @click.native="updateQueryUri('notifications')"
              name="Notificações" id="tab-notifications"
          >
            <Notifications/>

          </Tabs>

          <tabs
              v-if="$withPolicy('application', 'api')"
              :start-active="tab === 'api'"
              @click.native="updateQueryUri('api')"
              name="API e Integrações" id="api"
          >

            <APIAndIntegration/>
          </tabs>

        </TabContainer>

      </div>
    </div>

  </div>

</template>

<script>
  import APIAndIntegration from '@/components/definitions/APIAndIntegration'
  import CompanyContainer from './company/Container'
  import CredentialContainer from '@/components/credentials/Container'

  import EventContainer from '@/components/event/Container'
  import GetAccountApps from '@/mixins/GetAccountApps'
  import GetUser from '@/mixins/GetUser'

  import MyAccount from '@/components/definitions/MyAccount'
  import Notifications from '@/components/definitions/Notifications'
  import PermissionGroupsContainer from '@/components/permission_groups/Container'
  import ProviderContainer from '@/components/providers/Container'

  import CustomFieldIndex from '@/components/custom_fields/Index'

  import TabContainer from './shares/TabContainer'
  import Tabs from './shares/Tab'
  import UserContainer from './user/Container'

  import VehicleContainer from '@/components/vehicles/Container'
  import DriverContainer from '@/components/drivers/Container'

  export default {
    components: {
      APIAndIntegration,
      CompanyContainer,
      CredentialContainer,
      EventContainer,
      MyAccount,
      Notifications,
      PermissionGroupsContainer,
      ProviderContainer,
      TabContainer,
      Tabs,
      CustomFieldIndex,
      UserContainer,
      VehicleContainer,
      DriverContainer
    },
    computed: {
      showProviders() {
        return this.getAccountApps.some(aa => aa.active && aa.name === 'dfe')
      },
      showVehicles() {
        return this.getAccountApps.some(aa => aa.active && ['cm-crono', 'cm-embarcador', 'cm-frotas', 'cm-taxas'].includes(aa.name))
      },
      showDrivers() {
        return this.getAccountApps.some(aa => aa.active && aa.name === 'cm-frotas')
      },
      showCustomFields() {
        return this.getAccountApps.some(aa => aa.active && ['cm-embarcador'].includes(aa.name))
      }
    },
    created() {
      let tab = this.$route.query.tab
      if (tab) this.tab = tab
    },
    data(){
      return {
        tab: 'account'
      }
    },
    methods: {
      updateQueryUri(value) {
        history.replaceState( {}, null, this.$route.path + '?tab=' + value)
      }
    },
    mixins: [GetAccountApps, GetUser],
    name: 'Definition'
  }
</script>

<style lang="scss" scoped>
</style>
